import { AnchorLink } from 'components/anchorLink';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useBlockScroll } from 'hooks/useBlockScroll';
import { RootState } from 'lib/centralStore';
import { useSelector } from 'react-redux';
import { IppicaLegenda } from '../ippicaLegenda';
import styles from './IppicaNavMobile.module.scss';

export type IppicaNavMobileProps = {
  children?: React.ReactNode;
};

export const IppicaNavMobile = ({ children }: IppicaNavMobileProps) => {
  const { isNavMobileOpened } = useSelector((store: RootState) => store.ippica);

  useBlockScroll(isNavMobileOpened);

  const labelRisultati = useGetLabelByKey('risultati-e-partenti');

  return (
    <div className={`${styles.container} ${isNavMobileOpened ? styles.visibile : styles.hidden}`}>
      <div className={styles.childrenWrapper}>{children}</div>

      <div className={styles.linkWrapper}>
        <AnchorLink href={`${process.env.NEXT_PUBLIC_IPPICA_RISULTATI_PARTENTI}`} className={styles.link}>
          {labelRisultati}
        </AnchorLink>
        <IppicaLegenda />
      </div>
    </div>
  );
};
